/**
 * Версии служб контура через Gateway: реестр служб на сервере, версия, коммит, дата сборки и выкатки каждой.
 * Только с сессией; адресов служб ответ не содержит. `refresh=true` — не ждать кэш шлюза (он сам ограничивает частоту).
 */
export const PLATFORM_ABOUT_URLS = {
  about: '/api/gateway/v1/about',
  aboutFresh: '/api/gateway/v1/about?refresh=true',
} as const
